import { useContext, useMemo } from 'react'

import { PassContext } from "../../pass-context"

export default ({ show }) => {
  const { template, templateId, applePreviewVersion, clientId } = useContext(PassContext)
  const ownerClientId = Number(clientId ?? template?.client_id)
  const validOwnerClientId = Number.isFinite(ownerClientId) ? ownerClientId : 0

  const previewUrl = useMemo(() => {
    if (!templateId) return null
    const version = applePreviewVersion ?? Date.now()
    return `https://s3.eu-west-1.amazonaws.com/images.smartix.uk/${validOwnerClientId}/template_previews/${templateId}.png?v=${version}`
  }, [templateId, validOwnerClientId, applePreviewVersion])

  if (show) {
    return (
      <div className="front-minature">
        <div className="minature">
          {previewUrl && <img src={previewUrl} alt="Apple pass front preview" />}
        </div>
      </div>
    )
  }
}
